import { Avatar, Box, Divider, Typography, styled } from "@mui/material";
import { stringAvatar } from "./utils/Helper";
import { LogoutTwoTone } from "@mui/icons-material";
import { signOut } from "aws-amplify/auth";
import { useCallback, useState } from "react";
import useLogoutApps from "./hooks/useLogoutApps";
import { LoadingButton } from "@mui/lab";
import AuthHelper from "./utils/AuthHelper";

type ComponentProps = {
  heading?: string;
  subheading?: string;
};

const StyledLogoutButton = styled(LoadingButton)(() => ({
  borderRadius: 8,
  textTransform: "none",
  fontFamily: "Poppins, sans-serif",
  fontWeight: 600,
  fontSize: 12,
  padding: "6px 14px",
  minWidth: "auto",
  backgroundColor: "#EE2D41",
  color: "#FFFFFF",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: "#C41E30",
    boxShadow: "none",
  },
  "& .MuiLoadingButton-loadingIndicator": {
    color: "#FFFFFF",
  },
}));

function Header(props: ComponentProps) {
  const { logoutFormAllApps } = useLogoutApps();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const authHelper = new AuthHelper();
  const userData = authHelper.decodeTokenId();

  const signOutHandler = useCallback(async () => {
    setIsLoggingOut(true);
    logoutFormAllApps();
    await signOut();
    setIsLoggingOut(false);
  }, [logoutFormAllApps]);

  let displayUserName = userData.name;
  try {
    if (!displayUserName) {
      displayUserName = userData.email.split("@")[0];
    }
  } catch (error) {
    console.error("Error fetching user info:", error);
  }

  const avatarProps = displayUserName
    ? stringAvatar(displayUserName.toUpperCase())
    : {};

  const phoneNumber = (userData.phone_number || "").replace("+91", "");

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          px: 2.5,
          py: 2,
        }}
      >
        {displayUserName && (
          <Avatar
            {...avatarProps}
            sx={{
              ...(avatarProps as any).sx,
              width: 42,
              height: 42,
              fontSize: 15,
              fontWeight: 700,
              flexShrink: 0,
            }}
          />
        )}

        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            sx={{
              fontFamily: "Poppins, sans-serif",
              fontWeight: 700,
              fontSize: 14,
              color: "#0B1B2E",
              lineHeight: 1.3,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {phoneNumber || userData.name || userData["cognito:username"]}
          </Typography>
          <Typography
            sx={{
              fontFamily: "Poppins, sans-serif",
              fontWeight: 400,
              fontSize: 12,
              color: "#6B7A8D",
              lineHeight: 1.4,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {userData.email}
          </Typography>
        </Box>

        <StyledLogoutButton
          variant="contained"
          disableElevation
          size="small"
          loading={isLoggingOut}
          onClick={signOutHandler}
          startIcon={<LogoutTwoTone sx={{ fontSize: "16px !important" }} />}
        >
          Logout
        </StyledLogoutButton>
      </Box>

      <Divider sx={{ borderColor: "rgba(0,0,0,0.06)" }} />

      {(props.heading || props.subheading) && (
        <Box sx={{ px: 2.5, py: 1.5, bgcolor: "#F8FAFC" }}>
          <Typography
            sx={{ fontFamily: "Poppins, sans-serif", fontWeight: 600, fontSize: 14, color: "#0B1B2E" }}
          >
            {props.heading}
          </Typography>
          {props.subheading && (
            <Typography
              sx={{ fontFamily: "Poppins, sans-serif", fontWeight: 400, fontSize: 12, color: "#6B7A8D" }}
            >
              {props.subheading}
            </Typography>
          )}
        </Box>
      )}
    </>
  );
}

export default Header;
